import React from "react";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <p>Spot an issue or want a feature added? Just send us a note.</p>
          <a href="mailto:goalguesser@mail.com" className="footer-email">
            goalguesser@mail.com
          </a>
        </div>
        <div className="footer-links">
          <a href="/privacy-policy.html">Privacy Policy</a>
          <span className="footer-separator">|</span>
          <a href="/terms-of-service.html">Terms of Service</a>
        </div>
        <div className="footer-legal">
          <p className="footer-copyright">© 2026 Goal Guesser</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
